import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import DateForm from "../../../Components/DateForm/DateForm";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import { getPostPaymentDetails } from "../../../Helpers/APIEndPoints/EndPoints";

import notify from "../../../Helpers/ToastNotification";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { Decrypt } from "../../../Helpers/Cryptography/Crypto";

const PaymentVerificationView = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [disabled, setDisabled] = useState(false);
  const [showHideButton, setShowHideButton] = useState(false);
  const { state } = useLocation();
  const memberid = state.id ? state.id : "";

  // const memberid = GetDecryptedMemberIdFromLocalStorage();

  const [data, setData] = useState({
    initialDeposit: null,
    monthlyDeductions: null,
    totalPayable: null,
    accholdername: "",
    bankName: "",
    ifsc: "",
    accountNo: null,
    transactionRef: null,
    amount: null,
    transactionDate: null,
    typeoftransaction: null,
  });

  const transactionOption = [
    { label: "IMPS", value: "IMPS" },
    { label: "RTGS", value: "RTGS" },
    { label: "NEFT", value: "NEFT" },
  ];
  const location = useLocation();
  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };
  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("memberid")) {
        let encMemberId = params.get("memberid");
        // let memberid = decodeURIComponent(Decrypt(encMemberId));
        let decodeURLMember = decodeURIComponent(Decrypt(encMemberId));
        const parts = decodeURLMember.split('||');
        let memberid = parts[0];
        getPaymentDetailsByMemberId(memberid);
      }
    }
  }, [location.search]);

  // useEffect(() => {
  //   (async () => await getPaymentDetailsByMemberId())();
  // }, []);

  const getPaymentDetailsByMemberId = async (memberid) => {
    showLoader();

    let requestParams = { MemberId: memberid };
    const res = await APICall(getPostPaymentDetails, requestParams);
    
    if (res.Message === "Ok" && res.Data !== null) {
      let obj = {
        initialDeposit: res.Data.InitialDeposit,
        monthlyDeductions: res.Data.MonthlyDeductions,
        totalPayable: res.Data.TotalPayable,
        accholdername: res.Data.AccountHolderName,
        bankName: res.Data.BankName,
        ifsc: res.Data.IFSCCode,
        accountNo: res.Data.AccountNo,
        typeoftransaction: transactionOption.find(
          (d) => d.value === res.Data.TxnType
        ),
        transactionRef: res.Data.TxnReferenceNo,
        amount: res.Data.Amount,
        transactionDate: res.Data.TxnDate,
      };

      setData(obj);
      setDisabled(true);
      hideLoader();
    } else {
      notify(1, "No data found");
      setDisabled(true);
      setShowHideButton(true);
      hideLoader();
    }

    hideLoader();
  };

  return (
    <>
      <div className="">
        <div className="col-lg-12 col-md-12 p-0">
          <div className="row" style={{ marginTop: '15px' }}>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Initial Deposit</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.initialDeposit}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Monthly Deduction</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.monthlyDeductions}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Total Payable</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.initialDeposit}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Account Holder Name</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.accholdername}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("accholdername", value);
                  }}
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Bank Name</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.bankName}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("bankName", value);
                  }}
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>IFSC Code</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.ifsc}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("ifsc", value);
                  }}
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Account Number</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.accountNo}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("accountNo", value);
                  }}
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Type of Transaction</label>
                <sup>*</sup>
                <SelectForm
                  value={data.typeoftransaction}
                  placeholder=""
                  options={transactionOption}
                  isDisabled={disabled}
                  onChange={(val: any) => onChange("typeoftransaction", val)}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Transaction Reference No</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.transactionRef}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("transactionRef", value);
                  }}
                  type=""
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Amount</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.amount}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("amount", value);
                  }}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Transaction Date</label>
                <sup>*</sup>
                <DateForm
                  isDisabled={disabled}
                  value={data.transactionDate}
                  onChange={(val: any) => onChange("transactionDate", val)}
                />
                {/* {error[data.dob] && (
              <p style={{ color: "red" }}>{error[data.dob]}</p>
            )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentVerificationView;
